/* Quick buy (8 Oct 2026), after McGee & Co.

   On desktop a collection card shows an ADD TO CART bar on hover
   (button[data-quick-add], hidden below 1000px by quick-buy.css). The bar
   opens a window with the product's photos, price and pickers, rendered by
   sections/product-quick.liquid through the Section Rendering API. Its form
   is a [data-add-form], so cart.js does the adding, opens the cart drawer and
   fires `cart:added`; this file then closes the window.

   If anything here fails, the bar falls back to the product page. */
(function () {
  'use strict';
  if (!window.fetch || !document.addEventListener) return;

  var root = null, body = null, opener = null, busy = false;

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function shell() {
    if (root) return;
    root = document.createElement('div');
    root.className = 'qbm';
    root.hidden = true;
    root.innerHTML =
      '<div class="qbm__veil" data-qb-close></div>' +
      '<div class="qbm__panel" role="dialog" aria-modal="true" aria-labelledby="qb-title">' +
        '<div class="qbm__body" data-qb-body></div>' +
      '</div>';
    document.body.appendChild(root);
    body = root.querySelector('[data-qb-body]');
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-qb-close]')) close(true);
    });
  }

  function open(url, btn) {
    if (busy) return;
    shell();
    busy = true;
    opener = btn;
    body.innerHTML = '<div class="qbm__wait" aria-hidden="true"></div>';
    root.hidden = false;
    document.documentElement.classList.add('qb-open');
    requestAnimationFrame(function () { root.classList.add('is-open'); });

    var src = url + (url.indexOf('?') > -1 ? '&' : '?') + 'sections=product-quick';
    /* no Accept: application/json header: with it Shopify answers with the
       product's JSON instead of the rendered section */
    fetch(src)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        var html = json && json['product-quick'];
        if (!html) throw new Error('empty');
        body.innerHTML = html;
        var qb = body.querySelector('[data-qb]');
        if (!qb) throw new Error('no window');
        init(qb);
        var x = qb.querySelector('[data-qb-close]');
        if (x) x.focus();
      })
      .catch(function () { window.location.href = url; })
      .then(function () { busy = false; });
  }

  function close(giveFocusBack) {
    if (!root || root.hidden) return;
    root.classList.remove('is-open');
    document.documentElement.classList.remove('qb-open');
    setTimeout(function () { root.hidden = true; body.innerHTML = ''; }, 300);
    if (giveFocusBack && opener) opener.focus();
  }

  function init(qb) {
    var data;
    try { data = JSON.parse(qb.querySelector('[data-qb-data]').textContent); } catch (e) { return; }
    var opts = qb.querySelectorAll('[data-qb-opt]');
    var track = qb.querySelector('[data-qb-track]');
    var dots = qb.querySelector('[data-qb-dots]');
    var idField = qb.querySelector('[data-qb-id]');
    var price = qb.querySelector('[data-qb-price]');
    var add = qb.querySelector('[data-qb-add]');
    var more = qb.querySelector('[data-qb-more]');
    var prev = qb.querySelector('[data-qb-prev]');
    var next = qb.querySelector('[data-qb-next]');
    var shownColor = null;

    /* phone arrows: one photo at a time, greyed at either end */
    function arrows() {
      var n = track.children.length;
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      [prev, next].forEach(function (b) { if (b) b.hidden = n < 2; });
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    }
    function step(d) { track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    function chosen() {
      return Array.prototype.map.call(opts, function (f) {
        var r = f.querySelector('input:checked');
        return r ? r.value : null;
      });
    }
    function find(sel) {
      for (var i = 0; i < data.variants.length; i++) {
        var v = data.variants[i], ok = true;
        for (var k = 0; k < sel.length; k++) { if (v.options[k] !== sel[k]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    /* photos: the chosen colour's frames when the alt text names it (the same
       grammar the cards and the gallery read), studio frames first, eight at
       most; otherwise every photo */
    function paintMedia(sel) {
      var color = data.colorIndex > -1 ? sel[data.colorIndex] : null;
      if (color && color === shownColor) return;
      shownColor = color;
      var list = data.media.slice();
      if (color) {
        var word = ' ' + color.toLowerCase() + ' ';
        var mine = list.filter(function (m) {
          var a = ' ' + m.alt.replace(/,/g, ' ') + ' ';
          return a.indexOf(word) > -1 && a.indexOf('close up') < 0;
        });
        if (mine.length) list = mine;
      }
      list.sort(function (a, b) {
        return (b.alt.indexOf('in the studio') > -1) - (a.alt.indexOf('in the studio') > -1);
      });
      list = list.slice(0, 8);
      track.innerHTML = list.map(function (m) {
        return '<div class="qb__slide"><img src="' + esc(m.src) + '" alt="' + esc(m.alt) + '"></div>';
      }).join('');
      dots.innerHTML = list.length > 1 ? list.map(function (m, i) {
        return '<button type="button" aria-label="Photo ' + (i + 1) + '"' + (i ? '' : ' class="is-on"') + '></button>';
      }).join('') : '';
      track.scrollLeft = 0;
      arrows();
    }

    function update() {
      var sel = chosen();
      var v = find(sel);
      Array.prototype.forEach.call(opts, function (f, i) {
        var c = f.querySelector('[data-qb-chosen]');
        if (c && sel[i]) c.textContent = sel[i].split(' · ')[0];
        /* a value that cannot be bought with the other choices is greyed */
        f.querySelectorAll('input').forEach(function (r) {
          var test = sel.slice(); test[i] = r.value;
          var tv = find(test);
          var label = r.nextElementSibling;
          if (label) label.classList.toggle('is-out', !tv || !tv.available);
        });
      });
      if (v) {
        idField.value = v.id;
        price.textContent = v.price;
        if (more) more.href = v.url;
      }
      add.disabled = !v || !v.available;
      add.textContent = !v ? 'Unavailable' : (v.available ? 'Add to cart' : 'Sold out');
      paintMedia(sel);
    }

    qb.addEventListener('change', function (e) {
      if (e.target.matches('.qb__radio')) update();
    });
    dots.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var i = Array.prototype.indexOf.call(dots.children, b);
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
      arrows();
    }, { passive: true });

    update();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    open(btn.getAttribute('data-quick-add'), btn);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close(true);
  });
  /* cart.js has added the line and is opening the drawer */
  document.addEventListener('cart:added', function () { close(false); });
})();
